import React from "react";
import styled from "styled-components";
import { Edit2, Trash2, Eye, RotateCcw } from "react-feather";
import { Badge, Button, Row } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

/* Assets */
import background from "../img/BG.png";
import loginSeal from "../img/LoginSeal.png";
import leftBg from "../img/left-bg.png";
import rightBg from "../img/right-bg.png";

const StyledRed = styled.span`
  color: red;
`;

export const RequiredIndicator = <StyledRed>{"*"}</StyledRed>;

export const HeaderText = styled.h2`
  color: ${({ theme }) => theme.colors.headerTextBlue};
  margin-bottom: 0;
`;

export const StyledEditIcon = styled(Edit2)`
  color: ${({ theme }) => theme.colors.iconBlue};
  margin-right: 8px;
  cursor: pointer;
`;

export const StyledTrashIcon = styled(Trash2)`
  color: ${({ theme }) => theme.colors.iconBlue};
  cursor: pointer;
`;

export const StyledEyeIcon = styled(Eye)`
  color: ${({ theme }) => theme.colors.iconBlue};
  margin-right: 8px;
  cursor: pointer;
`;

export const StyledFontAwesomeIcon = styled(FontAwesomeIcon)`
  color: ${({ theme }) => theme.colors.iconBlue};
  cursor: pointer;
`;

export const StyledSaveIcon = styled(FontAwesomeIcon)`
  color: ${({ theme }) => theme.colors.iconBlue};
  margin-right: 8px;
`;

export const StyledCancelIcon = styled(FontAwesomeIcon)`
  color: ${({ theme }) => theme.colors.iconBlue};
`;

export const StyledResendIcon = styled(RotateCcw)`
  color: ${({ theme }) => theme.colors.iconBlue};
  margin-right: 8px;
  cursor: pointer;
`;

export const StyledBumpIcon = styled(FontAwesomeIcon)`
  color: ${({ theme }) => theme.colors.iconBlue};
  margin-right: 8px;
`;

// Comment buttons with theme colors
export const ViewCommentBtn = styled(Button)`
  color: white;
  background: ${({ theme }) => theme.colors.blue};
  border: 1px solid ${({ theme }) => theme.colors.blue};
  border-radius: 27px;
`;

export const AddCommentBtn = styled(Button)`
  background: #f8f8f8;
  border: 1px solid ${({ theme }) => theme.colors.blue};
  border-radius: 27px;
  color: ${({ theme }) => theme.colors.blue};
`;

export const AddButton = styled(Button)`
  background: ${({ theme }) => theme.colors.blue};
  box-shadow: none;
  border: 2px solid ${({ theme }) => theme.colors.black60};
  border-radius: 9px;
  height: clamp(35px, 5vw, 50px);
  font-weight: 500;
  display: flex;
  align-items: center;
  justify-content: center;

  @media (max-width: 575.98px) {
    p {
      display: none;
    }
  }
`;

export const CommentsContainer = styled.div`
  display: flex;
  align-items: flex-end;
  flex-direction: column;
  position: relative;

  &:has(.unread-msgs) {
    bottom: 10px;
  }
`;

export const CancelButton = styled(AddButton)`
  background: ${({ theme }) => theme.colors.white};
  border: 2px solid ${({ theme }) => theme.colors.secondaryRed};
  color: ${({ theme }) => theme.colors.secondaryRed};
`;

export const FormLabel = styled.h5`
  font-weight: bold;
`;

export const FormRow = styled(Row)`
  margin-top: 1.5rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const FormActionsSection = styled(Row)`
  margin-top: 3rem;
  display: flex;
  justify-content: flex-end;
`;

export const StyledCancelButton = styled(AddButton)`
  border-color: ${({ theme }) => theme.colors.buttonFormRed};
  width: 130px;
  margin-right: 1rem;
  color: ${({ theme }) => theme.colors.buttonFormRed};
  background: white;
`;

export const StyledSaveButton = styled(AddButton)`
  background: ${({ theme }) => theme.colors.buttonFormBlue};
  width: 130px;
`;

export const LayoutContainer = styled.div`
  background: #f3f3f3 url(${background}) no-repeat;
  background-position: center;
  background-size: cover;
  min-height: 100vh;
  padding: 2rem;
`;

export const LoginSeal = styled.div`
  background: url(${loginSeal}) no-repeat;
  height: clamp(500px, 50vh, 800px);
  width: 100%;
  background-position: center;
  background-size: contain;
  margin-top: 12rem;
`;

export const CongLayout = styled.div`
  height: 100%;
  padding: 2rem;
  background-image: url(${leftBg}), url(${rightBg});
  background-repeat: no-repeat, no-repeat;
  background-position: top left, top right;
  background-size: 20vw auto, 20vw auto;

  @media (max-width: 575.98px) {
    padding: 10px;
  }
`;

export const DistrictBackground = styled.div`
  background-color: white;
  min-height: 100vh;
  padding: 2rem;
  background-image: url(${leftBg}), url(${rightBg});
  background-repeat: no-repeat, no-repeat;
  background-position: top left, top right;
  background-size: 20vw auto, 20vw auto;
`;

export const LayoutBackground = styled.div`
  background-image: url(${leftBg}), url(${rightBg});
  background-repeat: no-repeat, no-repeat;
  background-position: top left, top right;
  background-size: 20vw auto, 20vw auto;
  height: 100%;
  padding: 2rem;
`;

export const CellText = styled.p`
  margin: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const ImageWrapper = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;

  @media (max-width: 575.98px) {
    margin-bottom: 2rem;
  }
`;

export const UploadButton = styled.label`
  border-radius: 9px;
  border: 1px solid #d8d8d8;
  background: ${({ theme }) => theme.colors.blue};
  width: 206px;
  height: 50px;
  color: white;
  box-shadow: 0px 2px 7px rgba(43, 53, 133, 0.27);
  align-items: center;
  display: flex;
  justify-content: center;
  margin-top: 1rem;
  cursor: pointer;
`;

export const UploadInput = styled.input`
  display: none;
`;

export const FormContainer = styled.div`
  margin-top: 50px;
`;

export const FormSection = styled.div`
  margin-top: 44px;
  padding-bottom: 4rem;
`;

export const FormHeaderSection = styled.div`
  margin-top: 24px;
  display: flex;
`;

export const CheckboxContainer = styled.div`
  width: 100%;
  padding: 0;
  margin: 0;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const UnreadBadge = styled(Badge)`
  height: initial;
  top: 9px;
  color: #5a69da;
  background-color: white !important;
  position: relative;
  box-shadow: 0px 4px 9px rgba(66, 82, 201, 0.38);
  font-size: small;
`;
